import { FetchResult } from '@apollo/client';
import _, { get, isFunction, isNil, noop } from 'lodash';
import DiscoverQueries from './DiscoverQueries';
import {
  ADD_VISUALIZATION_QUERY_NAME,
  visualizationFragment,
  visualizationFragmentName,
} from './Fragments';
import { makeReference } from '@apollo/client/utilities';
import { ApolloCache } from '@apollo/client/cache/core/cache';
import { IViz } from '../../discovery';
import { updateVisualizationOp } from '../graphql/DiscoverQueries';

export const buildCacheUpdate =
  (graphQLKey: string, cacheCallback = noop) =>
  (cache: ApolloCache<any>, { data: responseData }: FetchResult<any>) => {
    const updatingObject = get(responseData, graphQLKey);

    if (isNil(updatingObject?.id)) {
      return;
    }

    const cacheKey = cache.identify({
      __typename: 'DatasetVisualization',
      id: updatingObject?.id,
    });

    const cachedViz: Partial<IViz> = cache.readFragment({
      fragment: visualizationFragment,
      fragmentName: visualizationFragmentName,
      id: cacheKey,
    });

    const data = { ...cachedViz, ...updatingObject };

    isFunction(cacheCallback) && cacheCallback(cache, cacheKey, data);
  };

export const UpdateVizOptions = {
  update: buildCacheUpdate(updateVisualizationOp, (cache, cacheKey, data) => {
    cache.writeQuery({
      query: DiscoverQueries.UpdateVisualizationMutation,
      id: cacheKey,
      data: {
        [updateVisualizationOp]: data,
      },
    });
  }),
};

export const CreateVizOptions = {
  update: buildCacheUpdate(
    ADD_VISUALIZATION_QUERY_NAME,
    (cache: ApolloCache<any>, cacheKey, data) => {
      cache.writeQuery({
        query: DiscoverQueries.CreateVisualizationMutation,
        id: cacheKey,
        data: {
          [ADD_VISUALIZATION_QUERY_NAME]: data,
        },
      });

      cache.modify({
        fields: {
          visualizations(existingVisualizations = []) {
            return [...existingVisualizations, makeReference(cacheKey)];
          },
        },
      });
    },
  ),
};
